
import PreEntryApi from '../../assets/js/preentry'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { Message } from 'element-ui'

export default {
directives: {
TransferDom
},
components: {
XButton,
XInput,
Confirm,
OnboardHeader
},
data () {
return {
id: '',
publicId: '',
code: '',
status: '',
isError: false,
show: false,
errMsg: '',
initID: 'gZqLqd2T-qs',
locale: 'zh',
offerUrl: {
1: 'onboard.white_offer', // 白领英文模板
8: 'onboard.white_offer', // 白领英文模板
2: 'onboard.blue_offer', // 蓝领模板
3: 'onboard.store_offer', // 店端模板
5: 'onboard.intern_offer', // 实习生模板
6: 'onboard.intern_blue_offer', // 实习生蓝领模板
7: 'onboard.intern_store_offer', // 实习生蓝领模板
9: 'onboard.social_intern_store_offer', // 实习生蓝领模板
10: 'onboard.white_offer_rsu', // 白领模板
11: 'onboard.blue_offer_elementary', // 蓝领S0-S3版本
12: 'onboard.school_offer', // 校招模板
13: 'onboard.school_offer_ssp', // 校招模板(含股权)
14: 'onboard.school_store_offer', // 店端校招模板（新）
15: 'onboard.school_offer_bj', // 校招模板 - 北京（确认落户）
16: 'onboard.school_offer_sh', // 校招模板 - 上海（确认落户）
17: 'onboard.school_offer_sale', // 校招模板 - 售后
18: 'onboard.school_offer_prod', // 校招模板 - 产品交付
19: 'onboard.school_offer_prod_sale', // 校招模板 - 产品专家（电销）
20: 'onboard.school_offer_bj_chj', // 校招模板 - 北京车和家汽车科技
21: 'onboard.school_offer_sh_lxqc', // 校招模板 - 上海理想汽车
22: 'onboard.blue_offer_elementary_joint', // 蓝领S0-S3版本 - 合资
23: 'onboard.white_offer_joint', // 白领无股权模板 - 合资
24: 'onboard.white_offer_joint', // 蓝领S4-S9版本 - 合资
25: 'onboard.white_school_offer_stock', // 2023白领校招Offer Letter-含股权
26: 'onboard.white_school_offer', // 2023白领校招Offer Letter-不含股权
27: 'onboard.store_school_offer_sale', // 2023店端校招Offer Letter-电销&服务
28: 'onboard.store_school_offer_product', // 2023店端校招Offer Letter-产品交付&维修
29: 'onboard.white_school_offer_stock_rr', // 2022白领校招Offer Letter-含股权
30: 'onboard.white_school_offer_rr', // 2022白领校招Offer Letter-不含股权
31: 'onboard.store_school_offer_sale_rr', // 2022店端校招Offer Letter-电销&服务
32: 'onboard.store_school_offer_product_rr', // 2022店端校招Offer Letter-产品交付&维修
33: 'onboard.white_school_offer_xc', // 2023白领校招Offer Letter-四川理想新晨
34: 'onboard.white_school_offer_cdwl', // 2023白领校招Offer Letter-充电网络
35: 'onboard.white_school_offer_en', // 2023白领校招Offer Letter-不含股权（英文版）
36: 'onboard.white_school_offer_int_en', // 实习生offer模版（英文版）
37: 'onboard.school_sales_school', // 校企售后实习生offer

40: 'onboard.new_white_offer', // 白领模板
41: 'onboard.new_white_offer_en', // 白领英文模板
42: 'onboard.new_store_offer', // 店端offer
43: 'onboard.new_blue_offer', // 蓝领offer
44: 'onboard.new_intern_offer', // 实习offer
45: 'onboard.new_blue_research_offer', // 研发蓝领 offer
46: 'onboard.new_white_school_offer_stock', // 校招有股权 offer
47: 'onboard.new_white_school_offer', // 校招没股权 offer
48: 'onboard.new_white_school_offer_en', // 校招英文 不含股权 offer
49: 'onboard.new_store_school_offer', // 店端校招offer
50: 'onboard.new_white_school_charging_network_offer', // 白领校招充电网络
51: 'onboard.new_white_school_int_en_offer', // 校招实习生英文offer
52: 'onboard.new_blue_intern_offer', // 蓝领校企实习生
100: 'onboard.new_common_offer' // 公共模板
},
showMenus: false
}
},
computed: {
title: function () {
return this.$tsg('邮件')
}
},
watch: {
code: {

handler: function (val, oldval) {
if (this.code.length < 6) {
this.isError = false
}
},
deep: true
}
},
created () {
this.id = this.$route.query.id
this.publicId = this.$route.query.id
if (this.id === this.initID) {
this.title = this.$tsg('短信')
}
this.$forceUpdate()


PreEntryApi.checkID(
{ id: this.id },

(data, meta) => {
if (data) {
if (data.offer_type === 8) {
this.locale = 'en'




}
}
},
err => {
if (err === -1) {
this.$router.push({ name: 'onboard.404' })
}
},

err => {}
)
},
mounted () {
this.$refs.code.focus()
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(this.$route.query.locale)
this.$forceUpdate
},
methods: {
closeCode () {
this.show = true
},
onConfirm () {
setTimeout(window.close, 500)
var userAgent = navigator.userAgent
window.opener = null
window.open('', '_self', '')
window.close()
if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
window.location.href = 'about:blank'
window.close()
} else {
window.opener = null
window.open('', '_self', '')
window.close()
open(location, '_self').close()
}
},
checkCode () {
if (!this.code || this.code.length !== 6) {
this.errMsg = this.$tsg('验证码不正确，请重新输入。')
this.isError = true
return false
}

try {
PreEntryApi.checkCode(
{ code: this.code, id: this.id },

(data, meta) => {
if (data === '') {
this.errMsg = this.$tsg('验证码不正确，请重新输入。')
this.isError = true
return false
}


if (!window.localStorage) {

console.log('浏览器版本太低，不支持localStorage。')
return false
}

var localStorage = window.localStorage

if (data.token) {
localStorage.setItem('pre_token', data.token)
}
localStorage.setItem('pre_code', data.code)
localStorage.setItem('offer_zh', this.locale)

if (this.id === this.initID) {
this.id = data.id
}

this.locationHref(this.id, data)
},
(status, message) => {
if (status === -1) {
this.errMsg = this.$tsg('验证码不正确，请重新输入。')
}
if (message !== null) {
this.errMsg = this.$tsg(message)
}
this.isError = true
return false
}
)
} catch (e) {
this.errMsg = this.$tsg('系统错误，请联系管理员。')
this.isError = true
return false
}
},

specialOfferHref (isSubmit, erStatus, id) {
this.conditionJudge(isSubmit, erStatus, id, 'onboard.special_offer')
},

internOfferHref (jobType, isSubmit, erStatus, id, offerType, emailPost, isBlueCollar) {


if (!isSubmit && erStatus === 1) {
console.log(offerType)
if (!this.offerUrl[offerType]) {
const err = this.$tsg('未获取到Offer信息，请联系负责您的招聘人员。')
this.$message.error(err)
return false
}

this.$router.push({ name: this.offerUrl[offerType], query: { id: id } })


} else if (!isSubmit && erStatus === 3) {
this.$router.push({ name: 'onboard.list', query: { id: id } })


} else if ((isSubmit && erStatus === 2) || (isSubmit && erStatus === 1)) {
if (emailPost === 1 && isBlueCollar) {
this.$router.push({ name: 'onboard.info', query: { id: id } })
return
}
this.$router.push({ name: 'onboard.preview', query: { id: id, back: 1 } })
} else {
console.log(offerType)
if (!this.offerUrl[offerType]) {
const err = this.$tsg('未获取到Offer信息，请联系负责您的招聘人员。')
this.$message.error(err)
return false
}
this.$router.push({ name: this.offerUrl[offerType], query: { id: id } })
}
},

conditionJudge (isSubmit, erStatus, id, offerUrl) {
if (!isSubmit && erStatus === 1) {
this.$router.push({ name: offerUrl, query: { id: id } })


} else if (!isSubmit && erStatus === 3) {
this.$router.push({ name: 'onboard.list', query: { id: id } })


} else if ((isSubmit && erStatus === 2) || (isSubmit && erStatus === 1)) {
this.$router.push({ name: 'onboard.preview', query: { id: id, back: 1 } })
} else {
this.$router.push({ name: offerUrl, query: { id: id } })
}
},

locationHref (id, data) {





PreEntryApi.getSubmitStatus({ id: id }, (statusData, meta) => {
if (statusData) {
var isSubmit = statusData.isSubmit,
erStatus = statusData.er_status,
joinType = statusData.join_type,
offerType = statusData.offer_type,
isSpecialOffer = statusData.is_special_offer,
isIntern = statusData.is_intern,
isBlueCollar = statusData.is_blue_collar,
emailPost = statusData.email_post,
jobType = statusData.job_type,
status = statusData.status
if (status === 10) {
this.$router.push({ name: 'onboard.school_refuse_result', query: { id: id } })
return false
}
if (status === 11) {
const err = this.$tsg('您的offer已失效，请联系HR重新发送offer。')
this.$message.error(err)
return false
}

if (isSpecialOffer === 1) {
this.specialOfferHref(isSubmit, erStatus, id)
return
}


if (status === 4) {
this.$router.push({ name: this.offerUrl[offerType], query: { id: id } })
return
}


if (isIntern) {
this.internOfferHref(jobType, isSubmit, erStatus, id, offerType, emailPost, isBlueCollar)
return
}


if (this.publicId === this.initID) {
if (!isSubmit && erStatus === 3) {
this.$router.push({ name: 'onboard.list', query: { id: id } })
return false
} else if ((isSubmit && erStatus === 2) || (isSubmit && erStatus === 1) || status === 9) {
this.$router.push({ name: 'onboard.preview', query: { id: id, back: 1 } })
return false
} else {

this.$router.push({ name: 'onboard.privacy_tips', query: { id: id } })
return false
}
}



if (!isSubmit && erStatus === 1) {
if (!this.offerUrl[offerType]) {
const err = this.$tsg('未获取到Offer信息，请联系负责您的招聘人员。')
this.$message.error(err)
return false
}

this.$router.push({
name: this.offerUrl[offerType],
query: { id: id }
})
} else if (!isSubmit && erStatus === 3) {
this.$router.push({ name: 'onboard.list', query: { id: id } })


} else if ((isSubmit && erStatus === 2) || (isSubmit && erStatus === 1) || status === 9) {
if (emailPost === 1 && isBlueCollar) {
this.$router.push({ name: 'onboard.info', query: { id: id } })
return
}
this.$router.push({ name: 'onboard.preview', query: { id: id, back: 1 } })
} else {
if (!this.offerUrl[offerType]) {
const err = this.$tsg('未获取到Offer信息，请联系负责您的招聘人员。')
this.$message.error(err)
return false
}

this.$router.push({
name: this.offerUrl[offerType],
query: { id: id }
})
}
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/code.vue